import React from 'react';

export const SceneCard = ({
  scene,
  onClick,
  onEdit,
  isGM = false,
  isCurrent = false,
  hasRounds = false,
}) => {
  const characterCount = scene.characterIds?.length || 0;
  const aspectCount = scene.aspects?.length || 0;

  return (
    <div
      className={`relative p-4 rounded-lg border-2 transition-all ${
        isCurrent
          ? 'border-primary-500 bg-primary-50'
          : 'border-gray-200 bg-white hover:border-gray-300'
      } ${onClick ? 'cursor-pointer' : ''}`}
      onClick={onClick}
    >
      {/* Scene number badge */}
      <div className="absolute -top-2 -left-2 w-7 h-7 bg-gray-700 text-white rounded-full flex items-center justify-center text-sm font-bold">
        {scene.number}
      </div>

      {/* Current indicator */}
      {isCurrent && (
        <div className="absolute -top-2 right-2 px-2 py-0.5 bg-primary-500 text-white text-xs font-medium rounded-full">
          Current
        </div>
      )}

      <div className="ml-4">
        {/* Title */}
        <h4 className="font-medium text-gray-900">
          {scene.title || `Scene ${scene.number}`}
        </h4>

        {/* Description */}
        {scene.description && (
          <p className="text-sm text-gray-600 mt-1 line-clamp-2">
            {scene.description}
          </p>
        )}

        {/* Meta info */}
        <div className="flex items-center gap-3 mt-2 text-xs text-gray-500">
          {characterCount > 0 && (
            <span className="flex items-center gap-1">
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
              {characterCount}
            </span>
          )}
          {aspectCount > 0 && (
            <span className="flex items-center gap-1">
              <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M7 7h.01M7 3h5c.512 0 1.024.195 1.414.586l7 7a2 2 0 010 2.828l-7 7a2 2 0 01-2.828 0l-7-7A1.994 1.994 0 013 12V7a4 4 0 014-4z" />
              </svg>
              {aspectCount}
            </span>
          )}
          {scene.status === 'completed' && (
            <span className="text-green-600 font-medium">Completed</span>
          )}
        </div>

        {/* Edit button for GM */}
        {isGM && onEdit && (
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              onEdit(scene);
            }}
            className="mt-2 text-xs text-primary-600 hover:text-primary-700 font-medium"
          >
            Edit
          </button>
        )}

        {/* Warning if scene has rounds */}
        {hasRounds && isGM && (
          <p className="text-xs text-amber-600 mt-1">
            Has associated rounds
          </p>
        )}
      </div>
    </div>
  );
};
